/**
 * Mobile shell for the technician view (tracker item 42): a slim header with
 * a back link, the signed-in user and a "Full site" link. No desktop sidebar.
 */

import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const headerLink = 'inline-flex items-center min-h-[44px] px-2 text-sm font-semibold text-blue-700 hover:text-blue-900';

export function TechnicianLayout() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const onJob = pathname.startsWith('/tech/jobs/');

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="sticky top-0 z-20 bg-white shadow">
        <div className="mx-auto flex max-w-2xl items-center justify-between gap-2 px-2">
          {onJob ? (
            <Link to="/tech" className={headerLink}>&larr; Jobs</Link>
          ) : (
            <span className="px-2 text-sm font-bold text-gray-900">My jobs</span>
          )}
          <span className="min-w-0 flex-1 truncate text-center text-xs text-gray-500" data-testid="tech-user">{user?.email}</span>
          <Link to="/" className={headerLink}>Full site</Link>
        </div>
      </header>
      <main className="mx-auto max-w-2xl px-4 py-4 pb-16">
        <Outlet />
      </main>
    </div>
  );
}
